import axios, {
  AxiosHeaders,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { HttpError } from "@refinedev/core";
import toast from "react-hot-toast";
import CONFIG from "app-config/config.json";
import i18n from "utills/i18n";
import { handleAdminLogout } from "../utils/helper";

const AUTH_TOKEN = CONFIG.AUTH_TOKEN;
const BASE_URL = CONFIG.API;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(
  (request: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem("access-token");

    if (request.headers) {
      request.headers["Authorization"] = `Bearer ${AUTH_TOKEN}`;

      if (token) {
        request.headers["access-token"] = token;
      }
    } else {
      request.headers = new AxiosHeaders({
        Authorization: `Bearer ${AUTH_TOKEN}`,
        "access-token": token,
      });
    }

    return request;
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    const customError: HttpError = {
      ...error,
      message,
      statusCode: status,
    };

    const translatedMessage =
      i18n.t((message ?? "").replace(":", "")) || "Error has occured!";

    toast.error(translatedMessage, {
      ...(status === 401 ? { id: "401" } : {}),
      position: "top-right",
      duration: 6000,
    });

    if (status === 401) {
      setTimeout(() => {
        handleAdminLogout();
      }, 1000);
    }

    return Promise.reject(customError);
  }
);

export const request = <T = any>(
  config: AxiosRequestConfig
): Promise<AxiosResponse<T>> => {
  return axiosInstance.request<T>(config);
};
